import React, { useEffect, useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { Grid } from "@mui/material";
import IntervalDropdown from "../../components/IntervalDropdown";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dropdown } from "primereact/dropdown";
import { FREQUENCIES } from "../forms-allocation/constants";
import { QuillEditor } from "../../components/QuillEditor";
import { InputTextarea } from "primereact/inputtextarea";
import { PPEAddAPI, PPEUpdate } from "../../service/ppeService";
import ImageS3Upload from "../../components/ImageS3Upload";
import { placeholder } from "../../assets/placeholder";
import DropdownApi from "../../components/DropdownApi";
import { InputSwitch } from "primereact/inputswitch";
export default function PPEAdd(modalProps: any) {

  const details = modalProps?.details;
  const id = modalProps.uuid;
  const clientId = modalProps.clientId;

  const [name, setName] = useState(details?.name || "");
  const [nameError, setNameError] = useState(false);

  const [description, setDescription] = useState(details?.description || "");
  const [industry, setIndustry] = useState(details?.industry || []);
  const [hazard, setHazard] = useState(
    details?.hazard || []
  );
  const [question, setQuestion] = useState(details?.question || []);

  const [photo, setPhoto] = React.useState(details?.photo || placeholder);
  const [file, setFile] = React.useState<File>();
  const [s3Key, setS3Key] = useState(details?.s3_key || `ppe/${id}`);
  const [expectedLifeValue, setExpectedLifeValue] = React.useState(details?.expected_life_value || "");
  const [expectedLifeInterval, setExpectedLifeInterval] = React.useState(details?.expected_life_interval || "");
  const [price, setPrice] = React.useState(details?.price || "");
  const [size, setSize] = React.useState(details?.size || "");
  const [frequency, setFrequency] = useState(details?.frequency || 1);
  const [appointment, setAppointment] = React.useState(details?.appointment || "");
  const [correctiveAction, setCorrectiveAction] = React.useState(details?.corrective_action || []);
  const [required, setRequired] = React.useState(details?.required || false);

  async function addIndustry() {
    setNameError(!name || name === "");
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }
    const updateDetails = {
      name,
      description,
      industry,
      hazard,
      question,
      corrective_action: correctiveAction,
      s3_key: s3Key,
      expected_life_value: expectedLifeValue,
      expected_life_interval: expectedLifeInterval,
      price,
      size,
      frequency,
      appointment,
      required
    };
    if (modalProps.id) {
      PPEUpdate(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "PPE Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      PPEAddAPI(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "PPE Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  useEffect(() => {
    if (file instanceof File) {
      const photoUrl = URL.createObjectURL(file);
      setPhoto(photoUrl);
    }
  }, [file]);

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Details">
          <br />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl>
                <ImageS3Upload
                  photo={photo}
                  setPhoto={setPhoto}
                  s3Key={s3Key}
                  file={file}
                  setFile={setFile}
                  disabled={!!clientId}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl sx={{ flexGrow: 1 }}>
                    <FormLabel>
                      Name<div style={{ color: "red" }}>*</div>
                    </FormLabel>
                    <FormControl
                      sx={{
                        display: { sm: "flex-column", md: "flex-row" },
                        gap: 2,
                      }}
                    >
                      <InputText
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        readOnly={!!clientId}
                        className="p-inputtext-sm PrimeSmallInput"
                      />
                    </FormControl>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <IntervalDropdown
                    label="Expected Life"
                    selectedInterval={expectedLifeInterval}
                    setSelectedInterval={setExpectedLifeInterval}
                    selectedValue={expectedLifeValue}
                    setSelectedValue={setExpectedLifeValue}
                    disabled={!!clientId}
                  />
                </Grid>
              </Grid>
              <br />
            </Grid>
            {
              !clientId && (
                <Grid item xs={6}>
                  <MultiDropdownApi
                    showAll={true}
                    apiPath="industry"
                    optionLabel="name"
                    optionValue="id"
                    label="Industry"
                    selectedData={industry}
                    setSelectedData={setIndustry}
                    disabled={!!clientId}
                  />
                </Grid>)
            }
            <Grid item xs={6}>
              <MultiDropdownApi
                apiPath="risk-hazard"
                optionLabel="name"
                optionValue="id"
                label="Hazard"
                selectedData={hazard}
                setSelectedData={setHazard}
                disabled={!!clientId}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel style={{ paddingBottom: 14 }}>
                  Price
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    type="text"
                    readOnly={!!clientId}
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Size
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputText
                    value={size}
                    readOnly={!!clientId}
                    onChange={(e) => setSize(e.target.value)}
                    type="text"
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Mandatory
                </FormLabel>
                <FormControl
                  sx={{
                    display: { sm: "flex-column", md: "flex-row" },
                    gap: 2,
                  }}
                >
                  <InputSwitch disabled={!!clientId} checked={required} onChange={(e) => setRequired(e.value)} />
                </FormControl>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <QuillEditor
                label="Description"
                hidePlaceholder={true}
                content={description}
                setContent={setDescription}
                toast={modalProps.toast}
                disabled={!!clientId}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel header="Checklist">
          <TabView>
            <TabPanel header="Questions">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Questions</FormLabel>
                    {
                      !clientId && (
                        <Button
                          type="button"
                          icon="pi pi-plus"
                          label="Add"
                          className="p-button-outlined"
                          size="small"
                          style={{
                            position: "absolute",
                            right: 0,
                            padding: 10,
                            marginTop: -15,
                          }}
                          onClick={() => {
                            const updatedChecklist = [...question];
                            updatedChecklist.push("");
                            setQuestion(updatedChecklist);
                          }}
                        />
                      )
                    }
                  </FormControl>
                </Grid>
                {question.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        {
                          !clientId && (
                            <InputIcon
                              className="pi pi-trash"
                              style={{ color: "#eb445a" }}
                              onClick={() => {
                                const updatedChecklist = [...question];
                                updatedChecklist.splice(index, 1);
                                setQuestion(updatedChecklist);
                              }}
                            >
                              {" "}
                            </InputIcon>
                          )
                        }
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...question];
                            updatedChecklist[index] = e.target.value;
                            setQuestion(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          readOnly={!!clientId}
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
            <TabPanel header="Corrective Action">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Corrective Action</FormLabel>
                    {
                      !clientId && (
                        <Button
                          type="button"
                          icon="pi pi-plus"
                          label="Add"
                          className="p-button-outlined"
                          size="small"
                          style={{
                            position: "absolute",
                            right: 0,
                            padding: 10,
                            marginTop: -15,
                          }}
                          onClick={() => {
                            const updatedChecklist = [...correctiveAction];
                            updatedChecklist.push("");
                            setCorrectiveAction(updatedChecklist);
                          }}
                        />
                      )
                    }
                  </FormControl>
                </Grid>
                {correctiveAction.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        {
                          !clientId && (
                            <InputIcon
                              className="pi pi-trash"
                              style={{ color: "#eb445a" }}
                              onClick={() => {
                                const updatedChecklist = [...correctiveAction];
                                updatedChecklist.splice(index, 1);
                                setCorrectiveAction(updatedChecklist);
                              }}
                            >
                              {" "}
                            </InputIcon>
                          )
                        }
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...correctiveAction];
                            updatedChecklist[index] = e.target.value;
                            setCorrectiveAction(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          readOnly={!!clientId}
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
          </TabView>
        </TabPanel>
        <TabPanel header="Frequency">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl
                sx={{ display: { sm: "flex-column", md: "flex-row" } }}
              >
                <FormLabel>Frequency</FormLabel>
                <Dropdown className="PrimeSmallInput" style={{ fontSize: 'small', padding: 0 }}
                  onChange={(e: any) => setFrequency(e.value)}
                  options={FREQUENCIES}
                  value={frequency}
                  disabled={!!clientId}
                  optionLabel="label"
                  optionValue="value"
                  filterBy="label"
                  placeholder={`Select Frequency`} />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <DropdownApi disabled={!!clientId} apiPath='appointments' optionLabel="name" optionValue='id' label='Appointments' selectedData={appointment}
                setSelectedData={setAppointment}
              />
            </Grid>
          </Grid>
        </TabPanel>
      </TabView>
      <br />
      <br />
      {
        !clientId && (
          <CardOverflow
            style={{ width: "100%" }}
            sx={{ borderTop: "1px solid", borderColor: "divider" }}
          >
            <CardActions
              style={{ marginTop: 15 }}
              sx={{ alignSelf: "flex-end", pt: 2 }}
            >
              <Button
                name="button"
                icon="pi pi-save"
                label="Save"
                className="p-button-outlined"
                size="small"
                style={{
                  position: "absolute",
                  fontSize: "small",
                  right: 0,
                  color: "#2dd36f",
                }}
                onClick={() => addIndustry()}
              />
            </CardActions>
          </CardOverflow>
        )
      }
    </React.Fragment>
  );
}
